import initSideStripe from '../modules/side-stripe';

const initialized = new WeakSet();

export const sectionSelector = '.investment-content-section';

export function sectionCallBack(root) {
    root.querySelectorAll('.side-stripe').forEach(initSideStripe);

    const sidebar = root.querySelector('.left-side');
    if (!sidebar || initialized.has(sidebar)) return;
    initialized.add(sidebar);

    const desktop = window.matchMedia('(min-width: 1200px)');
    let frame = null;

    const update = () => {
        frame = null;
        const styles = getComputedStyle(sidebar);
        const top = Number.parseFloat(styles.top) || 0;
        const bottom = Number.parseFloat(styles.fontSize) * 2;
        const fits = sidebar.getBoundingClientRect().height + top + bottom <= window.innerHeight;

        sidebar.classList.toggle('is-sticky', desktop.matches && fits);
    };

    const schedule = () => {
        if (frame === null) frame = requestAnimationFrame(update);
    };

    const observer = new ResizeObserver(schedule);
    observer.observe(sidebar);
    const header = document.querySelector('#site-header');
    if (header) observer.observe(header);

    desktop.addEventListener('change', schedule);
    window.addEventListener('resize', schedule, { passive: true });
    document.fonts?.ready.then(schedule);
    schedule();
}
